import { render } from "./QuestionText.vue?vue&type=template&id=c757f890"
import script from "./QuestionText.vue?vue&type=script&lang=js"
export * from "./QuestionText.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__